export default __webpack_public_path__ + "static/media/brothers' dancing.e615214e.jpg";